import { render } from "./Footer.vue?vue&type=template&id=23357e35&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=23357e35&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\99170\\Desktop\\whole-project\\iridea-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23357e35"]])

export default __exports__